import React from 'react';
import {useI18nContext} from "../../../contexts/I18nContext";
import EditTopupProductEnableStore from "./EditTopupProductEnableStore";
import RoundedButton from "../../../ui_components/RoundedButton/RoundedButton";
import Modal from "../../../ui_components/Modal/Modal";
import {Observer} from "mobx-react-lite";
import {useStyles} from "./EditTopupProductEnableButton.style";
import Button from "../../../ui_components/Button/Button";
import ButtonType from "../../../ui_components/Button/ButtonType";
import {useCommonContext} from "../../../contexts/CommonContext";
import ButtonSize from "../../../ui_components/Button/ButtonSize";
import Switch from '@mui/material/Switch';
import Icon from '../../../ui_components/Icon/Icon';
import IconName from '../../../ui_components/Icon/enums/IconName';
import EditTopupProductEnableButtonProperties from './EditTopupProductEnableButtonProperties';
import clsx from 'clsx';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import Alert from '../../../ui_components/Alert/Alert';
import AlertType from '../../../ui_components/Alert/AlertType';
import TextInput from '../../../ui_components/TextInput/TextInput';

const EditTopupProductEnableButton: React.FC<EditTopupProductEnableButtonProperties> = ({
                                                                  onClick = () => {
                                                                  },
                                                                  onSave = () => {
                                                                  },
                                                                  showIcon = true,
                                                                  showText = true,
                                                                  disabled,
                                                                  className = '',
                                                                  topupProductId,
                                                                  rounded = false,
                                                                  size = ButtonSize.DEFAULT,
                                                                  type = ButtonType.DEFAULT
                                                              }) => {
    const classes = useStyles(showText);

    const i18n = useI18nContext();
    const commonContext = useCommonContext();
    const store = new EditTopupProductEnableStore(commonContext, topupProductId);

    const handleOnclick = async () => {
        await store.openModal();
        onClick();
    }

    const onCloseModal = () => {
        store.error = undefined;
        store.closeModal();
    }

    const onEnableChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        store.enable = event.target.checked;
    };

    const onProductIdChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        store.productId = event.target.value;
    };

    const onEnableSave = async () => {
        const saved = await store.save();
        if (saved) {
            store.closeModal();
            if (onSave) {
                onSave();
            }
        }
    }

    const text = 'Editar estado ';
    const btnIcon = <Icon name={IconName.EDIT_ICON}/>;
    const Btn = () => {
        if (rounded) {
            return <RoundedButton
                onClick={handleOnclick}
                className={className}
                disabled={disabled}
                tooltip={!showText ? text : ""}
                text={showText ? text : ""}
                type={type}
                icon={showIcon ? btnIcon : <></>}
            />
        }
        return <Button
            text={showText ? text : ""}
            className={className}
            tooltip={!showText ? text : ""}
            disabled={disabled}
            size={size}
            onClick={handleOnclick}
            type={type}
            startIcon={showIcon ? btnIcon : <></>}
        />
    }
    const StatusIcon = store.enable ? CheckCircleIcon : CancelIcon;

    return <Observer>
        {() => (
            <>
                <Modal fullScreen={false} loading={store.loading} title={text + store.topupProduct?.name} onClose={onCloseModal} open={store.isModalOpen}>
                    <div className={classes.modal_container}>
                        <div className={classes.status_container}>
                            <div className={clsx(classes.status_label, store.enable ? classes.active : classes.inactive)}>
                                <StatusIcon className={classes.status_icon}/>
                                <span>{i18n.translate(store.enable ? "ACTIVE" : "INACTIVE")}</span>
                            </div>
                            <Switch
                                checked={store.enable}
                                onChange={onEnableChange}
                            />
                        </div>
                        <Alert
                            className={classes.hint}
                            type={store.enable ? AlertType.INFO : AlertType.WARNING}
                            text={store.enable
                                ? 'El producto está activo. Se podrán realizar recargas para este producto.'
                                : 'El producto está inactivo. No se podrán realizar recargas para este producto.'}
                        />
                        {store.enable &&
                        <TextInput
                            label={'ID de producto (DT-One)'}
                            value={store.productId}
                            onChange={onProductIdChange}
                            className={classes.input}
                            fullWidth
                        />}
                        {store.error &&
                        <Alert
                            className={classes.hint}
                            text={i18n.translate(store.error)}
                            type={AlertType.DANGER}
                        />}
                        <div className={classes.actions_container}>
                            <Button
                                loading={store.loading} className={classes.cancel_btn} onClick={onCloseModal}
                                type={ButtonType.DEFAULT}
                                text={i18n.translate("CANCEL")}/>
                            <Button
                                disabled={!topupProductId}
                                loading={store.loading} className={classes.input} onClick={onEnableSave}
                                type={ButtonType.SECONDARY}
                                text={i18n.translate("SAVE")}/>
                        </div>
                    </div>
                </Modal>
                <Btn/>
            </>
        )}
    </Observer>
}

export default EditTopupProductEnableButton;
